export const wrapper = (size) => ({
    height: size,
    width: size,
    borderRadius: '12px',
    flexShrink: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const image = (size) => ({
    height: size,
    width: size,
    borderRadius: '12px',
    objectFit: 'cover',
    flexShrink: 0,
});

export const initialsText = (size) => ({
    fontSize: size * 0.35,
    fontWeight: 700,
    color: '#fff',
    lineHeight: 1,
    userSelect: 'none',
});
